//import $ from 'jquery';
import {gsap} from "gsap";
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { SplitText } from 'gsap/SplitText';
import { isMobile } from 'detect-touch-device';
import CustomAnimations from "src/scripts/modules/CustomAnimations";

var video  = $(".home_video");

const animations = new CustomAnimations();
let smoother;

function showPage(duration = 1) {

  gsap.to('.section', {
    rotate: 0,
    duration: duration,
    ease: "expo.out",
    scale: 1,
    y: 0
  });
}
function hidePage(duration = 1) {

  let pageRotation = -4;
  if(isMobile)
  {
    pageRotation = -2;
  }
  gsap.to('.section', {
    rotate: pageRotation,
    duration: duration,
    ease: "expo.out", //ease: "power3.out",
    scale: 1.4,
    y: '-=200px'
  });
}

function showPageCloser(url) {
  //alert('showPageCloser : ' + url);

  hidePage();

  setTimeout(function () {
    scrollTop();
  }, 500);

  var tl1 = gsap.timeline({});
  tl1.set('.pagecloser_logo', {
    alpha:0,
    rotate: -15,
    duration: 0,
    scale: .5}, 0);
  tl1.to('.pagecloser_logo', {
    alpha:1,
    rotate: 0,
    duration: 1,
    scale: 1,
    delay: 0}, 0);

  // pagecloser
  var tl = gsap.timeline({onComplete: showNewPage, onCompleteParams: [url] });
  tl.set('.pagecloser', {
    rotate: -4,
    top: '130%',
    scale: 1.2,
    duration:0}, 0);
  tl.to('.pagecloser', {
    rotate: -4,
    duration: 1,
    ease: "expo.out",
    repeat: 0,
    scale: 1.2,
    top: '0%'}, 0);
  tl.to('.pagecloser', {
    rotate: 0,
    duration: .5,
    ease: "expo.out",
    repeat: 0,
    scale: 1,
    top: '0%'}, .8);
}
function showNewPage(url) {

  if(process.env.NODE_ENV === 'production') {
    var newUrl = url.replace(".html","")
    url = newUrl;
  }

  window.location.href = url
}


function scrollTop() {
  smoother = animations.getSmoother();

  if (!isMobile) {
    gsap.to(smoother, {
      scrollTop: -1,
      duration: 0.1,
      ease: "power4.out",
    });
  }
  else {
    gsap.to(window, {
      duration: 0,
      ease: "power4.out",
      scrollTo:{
        y: -1,
        autoKill: false}
    })
  }
}

function playVideo() {
  video[0].play();
};

function pauseVideo() {
  video[0].pause();
};

class Home {
  init() {
    this.initPage();
    this.initListener();
    this.onScroll();
  }

  initPage = () => {
    gsap.registerPlugin(ScrollTrigger, SplitText);

    playVideo();
  }

  showPage = (duration) => {
    showPage(duration);
  }

  hidePage = (duration) => {
    hidePage(duration);
  }

  initListener = () => {
    gsap.set(".work_project_text", { transformOrigin: "50% 50%" });

    $(".work_project_holder").each(function (i, el) {
      let txt = $(".work_project_text", el);

      gsap.set(txt, {
        opacity: 0,
        x: 50
      });

      var tl = gsap.timeline({ paused: true });
      tl.set(txt, { willChange: "transform" })
      tl.to(txt, 0.4, { x: 25, opacity: 1, borderRadius: 15, ease: "power1.out" });

      el.animation = tl;

      $(el).on("mouseenter", function () {
        this.animation.play();
      }).on("mouseleave", function () {
        this.animation.reverse();
      }).on("click", function () {
        let url = $(this).data('url');
        showPageCloser(url);
      });
    });
  };

  onScroll = () => {
    jQuery(window)
      .scroll(function () {

        // set transform origin
        let scrollTop = $(window).scrollTop();
        let docHeight = $(document).height();
        let winHeight = $(window).height();
        let scrollPercent = (scrollTop) / (docHeight - winHeight);
        let scrollPercentRounded = Math.round(scrollPercent*100);
        let yOrigin = (scrollPercentRounded*.8)+'%';

        $('.page').css({
          'transform-origin': 'center' + ' ' + yOrigin
        });
        $('.main').css({
          //'transform-origin': 'center' + ' ' + yOrigin
        });


        if(scrollTop > 50) {
          pauseVideo();
        }
        else {
          playVideo();
        }

      }).scroll();
  };
}

export default Home;
